import { consumer, core } from '@tock/coretypes';

export const varietyToAllowsPartySizeSelection: {
  [K in core.TicketType.Variety | consumer.Offering.Type]: boolean;
} = {
  DEPOSIT: true,
  FULL: true,
  PRIX_FIXE: true,
  RESERVATION: true,
  DEPRECATED_EVENT: true,
  GA_EVENT: true,
  SEATED_EVENT: true,
  DEPRECATED_SPECIAL_TABLE: true,
  ORDER_DELIVERY: true,
  ORDER_PICKUP: true,
  TABLESIDE: true,
};

export const descriptiveVarietyToAllowsPartySizeSelection: Record<
  core.DescriptiveVariety,
  boolean
> = {
  TOGO_A_LA_CARTE: false,
  TOGO_PACKAGE: true,
  TOGO_PRIX_FIXE: true,
};

/**
 * Returns whether or not an experience variety and descriptive variety for an experiences allow guests to select party sizes.
 */
export function allowsPartySizeSelection(
  variety: core.TicketType.Variety | consumer.Offering.Type,
  descriptiveVariety?: core.DescriptiveVariety
): boolean {
  const varietyAllows = varietyToAllowsPartySizeSelection[variety];
  const descriptiveVarietyAllows =
    descriptiveVariety === undefined ||
    descriptiveVarietyToAllowsPartySizeSelection[descriptiveVariety];
  return varietyAllows && descriptiveVarietyAllows;
}
